export const UNIVERSITY_RATINGS = {
	MIN_QUANTITY: 1,
	MIN_AVERAGE: 1,
};
